import fastLogo from '../img/fastlogo.png';
import poshnoshLogo from '../img/poshnosh_logo_FOR  lights BACKGROUND.svg';
import aromiLogo from '../img/AROMI_logo_FOR WHITE BACKGROUND.svg';
import symposiumLogo from '../img/SYMOSIUM_logo_FOR  white  BACKGROUND.svg';
import nadimiLogo from '../img/NADIMI_logo.svg';
import copaLogo from '../img/copacabana_no_bg.png';
import italmarketLogo from '../img/italmarket.jpg';


import poshBg from '../img/POSH_NOSH/1.jpg';
import copaBg from '../img/copa/1.jpg';
import aromiBg from '../img/Aromi/3.jpg';
import sympBg from '../img/Simposium/1.jpg';
import nadimiBg from '../img/Nadimi/1.jpg';

export const RESTAURANT_META = {
    aromiitaliani: {
        name: 'Aromi Italiani',
        syrveKey: 'Aromiitaliani',
        url: 'aromiitaliani',
        rating: 4.8,
        time: '35',
        type: 'Italian Restaurant',
        featured: false,
        logo: aromiLogo,
        bg: aromiBg,
        deliveryFee: 0,
        reviewCount: '200+',
        rewardThreshold: 100,
    },
    poshnosh: {
        name: 'Poshnosh',
        syrveKey: 'PoshNoshs',
        url: 'poshnosh',
        rating: 4.9,
        time: '25-35',
        type: 'Street Food Cafe',
        featured: true,
        logo: poshnoshLogo,
        bg: poshBg,
        deliveryFee: 0,
        reviewCount: '120+',
        rewardThreshold: 150,
    },
    copacabana: {
        name: 'Copacabana',
        syrveKey: 'CopaCabana',
        url: 'copacabana',
        rating: 4.7,
        time: '40',
        type: 'Brazilian Fusion',
        featured: false,
        logo: copaLogo,
        bg: copaBg,
        deliveryFee: 0,
        reviewCount: '85+',
        rewardThreshold: 100,
        coloredLogo: true,
    },
    symposium: {
        name: 'Symposium',
        syrveKey: 'Symposium',
        url: 'symposium',
        rating: 4.5,
        time: '20',
        type: 'Wine Lounge',
        featured: false,
        logo: symposiumLogo,
        bg: sympBg,
        deliveryFee: 0,
        reviewCount: '60+',
        rewardThreshold: 50,
    },
    nadimi: {
        name: 'Nadimi',
        syrveKey: 'Nadimi',
        url: 'nadimi',
        rating: 4.8,
        time: '45',
        type: 'Georgian Cuisine',
        featured: false,
        logo: nadimiLogo,
        bg: nadimiBg,
        deliveryFee: 0,
        reviewCount: '150+',
        rewardThreshold: 100,
        coloredLogo: true,
    },
    fastdelivery: {
        name: 'Fast Delivery',
        logo: fastLogo,
        rewardThreshold: 100,
        coloredLogo: true,
    },
    italmarket: {
        name: 'Italmarket',
        syrveKey: 'Italmarket',
        url: 'italmarket',
        rating: null,
        time: null,
        type: 'Italian Market',
        featured: false,
        logo: italmarketLogo,
        bg: italmarketLogo,
        deliveryFee: 0,
        reviewCount: null,
        rewardThreshold: 0,
        comingSoon: true,
        coloredLogo: true,
    },
};

export const RESTAURANT_LIST = Object.values(RESTAURANT_META);
export const FEATURED_RESTAURANT = RESTAURANT_LIST.find(r => r.featured);
export const NON_FEATURED_RESTAURANTS = RESTAURANT_LIST.filter(r => !r.featured);

export const TOP_SALES_ITEMS = [
    { id: 1, name: 'Margherita Pizza', brand: 'Aromi Italiani', price: '22.00', restaurant: 'aromiitaliani', image: aromiBg },
    { id: 2, name: 'Classic Cheeseburger', brand: 'Poshnosh', price: '18.50', restaurant: 'poshnosh', image: poshBg },
    { id: 3, name: 'Spicy Tuna Roll', brand: 'Copacabana', price: '26.00', restaurant: 'copacabana', image: copaBg },
    { id: 4, name: 'Khinkali', brand: 'Nadimi', price: '12.00', restaurant: 'nadimi', image: nadimiBg },
    { id: 5, name: 'Wine Board', brand: 'Symposium', price: '35.00', restaurant: 'symposium', image: sympBg },
];

export const getRestaurantMeta = (companyKey) => {
    if (!companyKey) return null;
    const key = companyKey.toLowerCase();
    return RESTAURANT_META[key] || null;
};

export const LOYALTY_RESTAURANTS = ['aromiitaliani', 'fastdelivery', 'poshnosh', 'nadimi', 'copacabana', 'symposium'];

export const getMetaBySyrveKey = (syrveKey) => {
    if (!syrveKey) return null;
    const key = String(syrveKey).toLowerCase();
    return RESTAURANT_LIST.find(r => r?.syrveKey && String(r.syrveKey).toLowerCase() === key) || null;
};
